import Axios from 'axios'
import { getCookie, setCookie } from './cookie'
import Api from './api.js'
import { setTimeout } from 'core-js';
import { ElMessage } from 'element-plus'
import router from '@/router';
import Md5 from "js-md5";
var errFlag = true;//解决循环弹出错误提示标识
var noUseFlag = true;//解决循环弹出"服务不可以，联系管理员"标识

let pendingRequestArr = [];//保存pending状态的网络请求 
export function request(config) {
	let cancelToken = Axios.CancelToken;

	let authorization = null;
	if (getCookie("userInfo")) {
		if (JSON.parse(getCookie("userInfo"))) {
			authorization = JSON.parse(getCookie("userInfo")).tokenType + " " + JSON.parse(getCookie("userInfo")).accessToken
		}
	}
	// authorization="bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJwbGF0X2FkbWluIiwidXNlcl9uYW1lIjoicGxhdF9hZG1pbiIsIm9wZW5JZCI6IjIiLCJ1c2VySWQiOjIsImF1dGhvcml0aWVzIjpbIlJPTEVfdXNlciIsIlJPTEVfYWRtaW4iLCJST0xFX2FjY291bnQiLCJhdXRoZWQiLCJhY3RpdmVkIl0sImV4cCI6MTY4MzcyNzgxN30.sMpX-0RdgPcHkrRDs6k4BOOLyViftCczM-_ieCQsB7EQ8573tq0OHjoBWPMDsLDoUymlKi6qyAu7CQP_DCeYWDTBFLHNDVWtdVHnfa-eOED2UhCwoUXSsqle2ZGZJHYYpKspskV-LQm53H344CGafCTLc8vwVN0E0AaSbol_ZeDIq_sW5eaYHmVIKfMtiJ_mMv74MBYJw9HJUObkPefD1wRoMJbm-scMFYQQqorpYBU5owPZsU6KTKs69wFKErGHTaQ3dhkKwVtjG_apC8_kzd0xJ8xF3DuEC_-Y5gGSVlNUe-mMIzlsvbmX461C4xwy5DAVD2A6-dWHEi80Jb_Ziw"
	setCookie('authorization',authorization)
	//取消请求fn
	let cancelPendingFn = (res) => {
		// pendingRequestArr.forEach((item,index)=>{
		// 	if(item.url==res.url){
		// 		item.cancelFn();
		// 		pendingRequestArr.splice(index,1);//从数组移除当前请求记录
		// 	}
		// })
	}

	//创建Axios实例，添加通用配置
	const instance = Axios.create({
		method: config.method ? config.method : "post",
		timeout: config.timeout ? config.timeout : 30000,
		headers: config.header ? config.header : {
			// 'content-type': 'application/json',
			'Authorization': authorization,
			'withCredentials': true
		},
	})


	//实例请求拦截器
	instance.interceptors.request.use((res) => {
		return new Promise(resolve=>{
			setTimeout(()=>{
				// let url = config.url;
				// console.log(config)
				//
				// if(url.includes("/w/equ")){
				// 	config.headers.add("appId", Md5("0ca175b9c05726a831d"))
				// }
				cancelPendingFn(res);
				if(!res.url){return}
				if(res.url && res.url.substr(0,4).toLowerCase() == "http" ){
					res.url;
				}else{
					res.url = process.env.VUE_APP_BASE_API+process.env.VUE_APP_PUBLIC_NAME+Api[res.url]
				}
				res.cancelToken = new cancelToken((cancelFn) => {
					pendingRequestArr.push({ "url": res.url, "cancelFn": cancelFn })
				})
				let url = res.url;
				if(url.includes("/w/equ")){
					res.headers.appId = Md5("0ca175b9c05726a831d");
				}
				resolve(res)
			},300)
		})
	}, (err) => {
		return Promise.reject(err);
	})

	//实例响应拦截器
	instance.interceptors.response.use((res) => {
		if(res.data.code && res.data.code!='000' && res.data.code!='20000'){
			if (noUseFlag && !res.config.cancelMsg) {
				noUseFlag = false;
				ElMessage.error({
					message: res.data.msg,
					duration: '2500',
					onClose: function () {
						noUseFlag = true;
					}
				});
			}
		}
		//cancelPendingFn(res.config);
		return res;
	}, (error) => {

		let err = error.response;
		if (errFlag) {
			if(err){
				if (err.status == "401") {
					setCookie('userInfo', '');
					setCookie('loginName', '');
					router.push({
						path:'login'
					})
				} else if (err.status == "500") {
					// errFlag = false;
					ElMessage({
						message: err.data.msg,
						onClose: function () {
							errFlag = true;
						}
					});
				}
			}else{
				ElMessage({
					message: err.message,
					onClose: function () {
						errFlag = true;
					}
				});
			}
			
		}



		// var isErrInfo = err.response.data.error_description.indexOf('Access token expired');//权限是否过期
		//    var isErrInfo1 = err.response.data.error_description.indexOf('An Authentication object was not found in the SecurityContext');//没有token串
		//       if(errFlag) {
		//         if( isErrInfo>=0 ) {
		//           setCookie('userInfo','');
		//           setCookie('loginName','');
		//           localStorage.setItem("menuBuyType","");
		//           errFlag = false;
		//           vm.$router.push('/'); 
		//         } else if( isErrInfo1>=0 ) {
		//           errFlag = false;
		//           vm.$router.push('/'); 
		//         } else {
		//           ElMessage('服务暂时不可用，请联系管理员');
		//         }
		//         return false;
		//       }
		//return Promise.reject(err);
		return Promise.reject(err).catch((error) => {
			if (error.data == "server exception: code = 404 msg = Not Found") {//说明没开通此服务
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: '服务暂时不可用，请联系管理员',
						duration: '4000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			if (error.status == '500') {
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: error.data.msg ? error.data.msg : '服务端异常',
						duration: '3000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			if (error.status == '403') {
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: error.data.msg ? error.data.msg : '服务端异常',
						duration: '3000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			return Promise.reject(err);//为了在具体页面请求中 catch中获取错误信息
		});
		
	})

	//返回axios的实例，也是一个promise
	return instance(config)
	
}

/*
具体页面中使用方式
request({
	url:"xxxx",
	method:"post",
	data:{},
}).then((res)=>{

}).catch((err)=>{

})

*/
